<div class="facebook-login-block">
    <a class="facebook-login-link"
       [ngClass]="{'btn': isFacebookFundraiserPage, 'btn-primary': isFacebookFundraiserPage}"
       (click)="continueWithFacebook()">
        <img *ngIf="isFacebookFundraiserPage" class="facebook-f-logo" src="assets/img/FB-f-Logo__white_29.png"/> continue with facebook
    </a>
</div>
